import {Component, OnInit} from '@angular/core';
import {TeamService} from '@app/core/services/team.service';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {Trainer} from '@shared/models/trainer';
import {Formations, IFormation} from '@shared/models/lineup/formations';
import {LineupPlayer} from '@shared/models/lineup/lineup';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'app-match-lineup-tab',
  templateUrl: './match-lineup-tab.component.html',
  styleUrls: ['./match-lineup-tab.component.scss']
})
export class MatchLineupTabComponent implements OnInit {

  public formationHome: IFormation;
  public formationAway: IFormation;
  public trainerHome: Trainer = null;
  public trainerAway: Trainer = null;
  public entityType = EntityType.Event;

  constructor( public matchDetailViewService: MatchDetailViewService,
               public teamService: TeamService,
               private adCampaignService: AdCampaignService ) { }

  ngOnInit(): void {
    // Quick Fix till the correct trainers will be included in event
    this.getTrainers();
    this.setLineupFormation();
    this.adCampaignService.setPlacement(AdCampaignPlacement.Lineup);
  }

  async getTrainers() {
    try {
      let trainerHomeArray: Trainer[];
      let trainerAwayArray: Trainer[];
      [trainerHomeArray, trainerAwayArray] = await Promise.all([
        this.teamService.fetchTeamTrainers(this.matchDetailViewService.data.homeTeam.id),
        this.teamService.fetchTeamTrainers(this.matchDetailViewService.data.awayTeam.id)
      ]);

      trainerHomeArray?.slice().reverse().forEach(trainer => {
        if (trainer.position === "Cheftrainer" || trainer.position == "Co-Trainer") {
          this.trainerHome = trainer;
        }
      })

      trainerAwayArray?.slice().reverse().forEach(trainer => {
        if (trainer.position === "Cheftrainer" || trainer.position == "Co-Trainer") {
          this.trainerAway = trainer;
        }
      })
    } catch (error) {
      console.log(error);
    }
  }

  setLineupFormation () {
    const data = this.matchDetailViewService.data;
    if (!data.homeLineup || !data.awayLineup) {
      return;
    }
    this.formationHome = Formations[this.matchDetailViewService.data.homeLineup.formation + 1];
    this.formationAway = Formations[this.matchDetailViewService.data.awayLineup.formation + 1];
  }

  isLoading(): boolean {
    if (!this.matchDetailViewService || !this.matchDetailViewService.data ||
      !this.matchDetailViewService.data.homeTeam || !this.matchDetailViewService.data.awayTeam) {
      return true;
    }
    return false;
  }

  getAllPlayersOfHomeTeam(): LineupPlayer[] {
    if (!this.matchDetailViewService.data.homeLineup) {
      return [];
    }
    return this.matchDetailViewService.data.homeLineup.getAllLineupPlayers();
  }

  getAllPlayersOfAwayTeam(): LineupPlayer[] {
    if (!this.matchDetailViewService.data.awayLineup) {
      return [];
    }
    return this.matchDetailViewService.data.awayLineup.getAllLineupPlayers();
  }

  getReservePlayersOfHomeTeam(): LineupPlayer[] {
    if (!this.matchDetailViewService.data.homeLineup) {
      return [];
    }
    return this.matchDetailViewService.data.homeLineup.getAllReservePlayers();
  }

  getReservePlayersOfAwayTeam(): LineupPlayer[] {
    if (!this.matchDetailViewService.data.awayLineup) {
      return [];
    }
    return this.matchDetailViewService.data.awayLineup.getAllReservePlayers();
  }
}
